import CurrencyCollection from "./CurrencyCollection";

export default CurrencyCollection;
